// extracted by mini-css-extract-plugin
module.exports = {"colBtnCreate":"ConfigModal_colBtnCreate__qdiS0"};